
import classes from './AboutUs.module.css';
import Clipart from '../images/aboutus.png'
import { useNavigate } from 'react-router-dom';
import Typewriter from 'typewriter-effect';
const AboutUs=()=>{

const navigate=useNavigate();
const navFun=()=>{
    navigate('/');
}
    return(
        <>
         <div className={classes.navbar}>
           <div className={classes.navitems}>
           <h1 className="logo" onClick={navFun}>Resume Builder</h1>
           </div>
        </div>
        <div className={classes.mainDiv}>
         <div className={classes.left}>
         <h1 className={classes.header}>
         <Typewriter onInit={(typewriter)=> {
          typewriter.typeString("What are we?").pauseFor(1000).deleteAll().typeString("We are resume Builder").pauseFor(1000).start();
          }}
          options={{loop:true}}
          />
         </h1>
        <p>
        Resume Builder is a simple, easy to use wizard based website.
        We believe that landing a job and building the perfect resume should be simple, and that a poorly written resume 
        should be the last reason for not getting the job that you want. We’re dedicated to make sure that doesn’t 
        happen.
        </p>
         </div>
         <div className={classes.right}>
            <img src={Clipart} alt="aboutus" />
         </div>
        </div>
        <div className={classes.footer}>
        <p>Developed By: <a href="/about-us" style={{textDecoration:'none',color:'white'}}>Ayush Singh</a></p>
    </div>
        </>
    )
}
export default AboutUs;